<div class="sms-container">
  <div class="pattern">
    <div class="onyx-text"></div>
  </div>
</div>
